import { Col, Dropdown, Image, Row, Space, Typography } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { OX_DEPOT_FILTER } from "../../../../config/constants";
import { getFromLocal } from "../../../../helpers/handleLocalStorage";
import { useDepotChange } from "../../../../hooks/useDepotChange";
import { useGetUser } from "../../../../hooks/useGetUser";
import { useDepotsQuery } from "../../../../lib/api/endpoints/Depots/depotEndpoints";
import { getDepots } from "../../../../lib/redux/slices/depotsSlice";
import { SelectedDepotTypes } from "../../../../lib/types/depots";
import NewDepotModal from "../../../Modals/NewDepotModal";
import G_Image from "../../Image/G_Image";
import { G_Text } from "../../Text";
const { Text } = Typography;

const DepotSelector = () => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isNewDepotModalVisible, setIsNewDepotModalVisible] = useState(false);
  const { data, isLoading } = useDepotsQuery();
  const dispatch = useDispatch();
  const depotsState = useSelector(
    (state: { depots: { payload: SelectedDepotTypes } }) => state.depots.payload
  );

  useEffect(() => {
    const savedDepots = getFromLocal(OX_DEPOT_FILTER);

    dispatch(getDepots(savedDepots || { depotId: 0, depotName: "All depots" }));
  }, [dispatch]);

  const { onChange: handleDepotChange } = useDepotChange({
    onSuccess: () => setIsDropdownVisible(false)
  });

  const { isSuperAdmin } = useGetUser();

  const depots = (
    <Space
      className="depot_dropdown rounded-md p-0"
      direction="vertical"
      style={{ width: "250px" }}
    >
      {isSuperAdmin && (
        <div className="text-white border-b border-black p-5">
          <div className="bg-ox-yellow rounded">
            <Row align="middle" wrap={false}>
              <Col className="p-4 pb-3 border-r border-ox-shadow-dark">
                <Image
                  className="mt-1"
                  width={20}
                  src={`/icons/ic-ecommerce-house-white.svg`}
                  preview={false}
                  alt=""
                />
              </Col>

              <Col
                onClick={() => {
                  setIsDropdownVisible(false);
                  setIsNewDepotModalVisible(true);
                }}
                className="p-4 text-black font-bold pointer text_ellipsis"
              >
                Add new depot
              </Col>
            </Row>
          </div>
        </div>
      )}

      <div className="p-6 p-y-0 max-h-[60vh] overflow-y-auto">
        <p className="pl-4 text-gray-500">Select to switch depot</p>
        <Row
          className="p-4 cursor-pointer"
          onClick={() => handleDepotChange({ id: 0, name: "All depots" })}
          gutter={12}
          align="middle"
        >
          <Col>
            <Image
              width={16}
              src={`/icons/ic-ecommerce-house.svg`}
              preview={false}
              alt=""
            />
          </Col>
          <Col>
            <Text className="white text_ellipsis">All depots</Text>
          </Col>
        </Row>

        {data?.payload?.map((depot) => (
          <Row
            className={`p-4 cursor-pointer hover:bg-ox_2_black ${
              depot.id === depotsState.depotId && "bg-black"
            }`}
            onClick={() => handleDepotChange(depot)}
            gutter={12}
            align="middle"
            justify="space-between"
            key={depot?.id}
            wrap={false}
          >
            <Col>
              <Row align="middle" gutter={12} wrap={false}>
                <Col>
                  <Image
                    width={16}
                    src={`/icons/ic-ecommerce-house.svg`}
                    preview={false}
                    alt=""
                  />
                </Col>
                <Col>
                  <Text className="white text_ellipsis">{depot?.name}</Text>
                </Col>
              </Row>
            </Col>

            {depot.id === depotsState.depotId && (
              <Col>
                <Image
                  onClick={() => setIsDropdownVisible(!isDropdownVisible)}
                  width={12}
                  src={`/icons/check.svg`}
                  preview={false}
                  alt=""
                />
              </Col>
            )}
          </Row>
        ))}
      </div>
    </Space>
  );

  return (
    <>
      <NewDepotModal
        isVisible={isNewDepotModalVisible}
        setIsVisible={setIsNewDepotModalVisible}
      />

      <Dropdown
        trigger={["hover"]}
        disabled={isLoading}
        overlay={depots}
        placement="bottom"
        className="pointer"
      >
        <Row
          align="middle"
          gutter={12}
          justify="space-between"
          className="w-[228px] pr-8"
        >
          <Col>
            <Row align="middle" gutter={16}>
              <Col>
                <G_Image src="/icons/house-icon.svg" height={16} width={16} />
              </Col>

              <Col className="cursor-pointer">
                <G_Text color="ox_2_white" weight="medium" pointer>
                  {depotsState?.depotName}
                </G_Text>
              </Col>
            </Row>
          </Col>

          <Col>
            <G_Image src="/icons/dropdown-icon.svg" width={12} height={12} />
          </Col>
        </Row>
      </Dropdown>
    </>
  );
};

export default DepotSelector;
